import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Ticket } from "lucide-react";
export default function GetYourTickets() {
  return <section id="get-your-tickets" className="dark bg-background text-foreground relative overflow-hidden py-32 md:py-48 flex flex-col items-center justify-center">
      {}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 flex items-center justify-center opacity-20 select-none pointer-events-none overflow-hidden">
        <div className="flex whitespace-nowrap animate-marquee">
          {Array.from({
          length: 10
        }).map((_, i) => <span key={i} data-index={i} className="text-[12rem] md:text-[20rem] font-black uppercase leading-none mx-4 text-transparent [-webkit-text-stroke:2px_theme(colors.neutral.800)]">
              TICKETS
            </span>)}
        </div>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-12">
        
        {}
        <div className="hidden md:block absolute left-1/4 top-1/2 -translate-y-1/2 -translate-x-1/2 -rotate-12 opacity-80 hover:opacity-100 transition-opacity duration-500">
           <img src="https://blkn.com.au/wp-content/uploads/2026/03/1J6A5460-scaled.jpg" alt="VIP Lanyard" className="w-32 md:w-48 drop-shadow-2xl" />
        </div>

        {}
        <div className="relative group">
          <div className="absolute -inset-1 bg-white/20 blur-xl rounded-none opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <Button asChild className="relative border-4 border-white bg-black text-white text-2xl md:text-4xl font-bold uppercase tracking-widest p-8 md:p-12 h-auto rounded-none hover:bg-white hover:text-black transition-all duration-300 hover:scale-105">
            <Link to="https://www.eventbrite.com" newTab>GET YOUR Tickets</Link>
          </Button>
        </div>

        {}
        <div className="md:hidden mt-8 rotate-12 opacity-60">
           <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572489/img/vip_lanyard_minimal.png" alt="VIP Lanyard" className="w-24" />
        </div>

      </div>
    </section>;
}